export default {"src":"/_next/static/media/camera.77e5518b.svg","height":29,"width":32,"blurWidth":0,"blurHeight":0};